// Picker bottom sheets on the web (token / account pickers on Operations and the deposit screens). In the app
// they stretch to the top of the screen and are closed by a swipe down — which a mouse can't do and a finger
// rarely tries in a browser, and with no free space left there is nothing to tap to get out. On the web the
// sheet takes at most the lower half and sits on a dimmed backdrop; a tap on the backdrop closes it.
import { Platform } from 'react-native';
import { COLORS } from '../src/theme/themeTokens';

const web = Platform.OS === 'web';

/**
 * On the sheet itself, after its own style: as tall as its rows, no more than half the screen. A sheet whose
 * rows are not in a ScrollView of their own scrolls as a whole.
 */
export const WEB_SHEET = web ? ({ flex: -1, marginTop: 0, maxHeight: '55%', overflow: 'auto' } as const) : null;

/** On a list inside the sheet that has `flex: 1`: let it take its rows' height and scroll past the limit. */
export const WEB_SHEET_LIST = web ? ({ flex: -1 } as const) : null;

/** On the full-screen layer under the sheet that closes it on a tap. */
export const WEB_SHEET_BACKDROP = web ? ({ backgroundColor: COLORS.overlay } as const) : null;
